// Route → screen table. Each tab owns the URLs below its name (#/route/…, #/more/…); screens are lazy so a phone
// downloads the code of a tab only when it is opened.

import { lazy, Suspense } from 'preact/compat';
import type { ComponentChildren } from 'preact';
import { t } from '../i18n';
import { Spinner } from './components/ui';
import type { Route } from './router';

const MapScreen = lazy(() => import('./map/MapScreen').then((m) => m.MapScreen));
const RouteTab = lazy(() => import('./route/RouteTab').then((m) => m.RouteTab));
const TonightScreen = lazy(() => import('./tonight/TonightScreen').then((m) => m.TonightScreen));
const TripTab = lazy(() => import('./trip/TripTab').then((m) => m.TripTab));
const MoreTab = lazy(() => import('./more/MoreTab').then((m) => m.MoreTab));
const SafetySheet = lazy(() => import('./safety/SafetySheet').then((m) => m.SafetySheet));

function Loading() {
  return (
    <div class="screen">
      <Spinner label={t('common.loading')} />
    </div>
  );
}

function suspended(node: ComponentChildren) {
  return <Suspense fallback={<Loading />}>{node}</Suspense>;
}

export const screens = {
  forRoute(r: Route): ComponentChildren {
    switch (r.path[0]) {
      case 'map':
        return suspended(<MapScreen />);
      case 'tonight':
        return suspended(<TonightScreen />);
      case 'trip':
        return suspended(<TripTab />);
      case 'more':
        return suspended(<MoreTab />);
      case 'route':
      default:
        return suspended(<RouteTab />);
    }
  },
  safety(): ComponentChildren {
    return <Suspense fallback={null}>{<SafetySheet />}</Suspense>;
  },
};
